/**
 * PlanScout advisor-experience design tokens.
 *
 * Single source of truth for the redesign palette (navy/Montserrat card design).
 * Components should import these instead of hard-coding hex literals — the legacy
 * "V4" palette (#1B3A5C, #2E75B6, #E67E22, #0F8B6E) is being migrated onto these.
 */
export const tokens = {
  // Brand
  navy: '#1B3A66',
  lightBlue: '#EDF1F7',
  // Aligned Investments accent (Financial Plan tab strip, mockup v5).
  blue: '#2F7BBF',

  // Positive / value
  green: '#2F8F5B',
  greenLight: '#EAF5EE',

  // Muted status colors
  gold: '#C99A5B',
  goldLight: '#F5EFE4',
  // Clear amber-orange for the "needs rerun" warning marker (matches mockup).
  orange: '#D97706',
  // Provenance marker for advisor-entered ("Direct Input") client-data values.
  purple: '#6D28D9',
  purpleLight: '#F1EBFA',
  clay: '#B0645C',
  clayLight: '#F3EDEC',
  sage: '#5A8A6B',
  sageLight: '#EDF3EF',

  // Surfaces
  bg: '#F6F7F9',
  card: '#FFFFFF',
  border: '#E3E6EB',

  // Text
  text: '#171B21',
  textSec: '#6B7480',
  textMut: '#9AA3AF',
} as const;

export const FONT_FAMILY =
  '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

export type Tokens = typeof tokens;
